import Cookies from 'js-cookie'
import { getConfigValue } from '~/helpers/envHelpers'

let SESSION_TOKEN = Cookies.get(getConfigValue('VITE_AUTH_TOKEN_NAME'))

export function setSessionToken(token: string) {
  Cookies.set(getConfigValue('VITE_AUTH_TOKEN_NAME'), token, {
    expires: 7,
    domain: getConfigValue('MODE') === 'development' ? '.happitu.local' : '.happitu.com',
  })
  SESSION_TOKEN = token
}

export function redirectToLogin() {
  window.location.href = '/login'
}

export function removeSessionToken() {
  Cookies.remove(getConfigValue('VITE_AUTH_TOKEN_NAME'), {
    domain: getConfigValue('MODE') === 'development' ? '.happitu.local' : '.happitu.com',
  })
  SESSION_TOKEN = undefined
}

export function getSessionToken() {
  return SESSION_TOKEN
}

export function setLastOrgAlias(alias: string) {
  Cookies.set('last-org-alias', alias, {
    expires: 365,
  })
}
